import React from "react";
import { Col, Row, Tab} from 'react-bootstrap';
import { BulkComponent } from "./createBulkCamp";

export default () => {
    return (
        <>
            <Row>
                <Col xs={12} xl={12}>
                    <Tab.Container defaultActiveKey="api-push">
                        <BulkComponent />
                    </Tab.Container>
                </Col>
            </Row>
        </>
    )
}